import { forwardRef, useEffect, useState } from "react";
import { companyVideoArchiveUrl, isCompanyVideoUrl } from "./company_video";

// Wraps a react-player component: if the Stream copy cannot be played, retry once with the R2 copy.
export default function withCompanyVideoFallback(Player) {
  const Wrapped = forwardRef(function CompanyVideoPlayer(props, ref) {
    const [url, setUrl] = useState(props.url);
    useEffect(() => setUrl(props.url), [props.url]);

    const handleError = (...args) => {
      if (isCompanyVideoUrl(url) && url.endsWith(".m3u8")) {
        setUrl(companyVideoArchiveUrl(url));
        return;
      }
      if (props.onError) props.onError(...args);
    };

    return <Player {...props} ref={ref} url={url} onError={handleError} />;
  });
  return Wrapped;
}
